<div class="artist" *ngIf="project">
    
    
    <div class="details">
        <div class="pad">
            <div class="inner scrollbars">
            <div class="header">
                <div class="img" [ngStyle]="{ 'background-image': bgProject }"></div>
                <div class="txt">
                    <div class="title">{{project.project_name}}</div>
                    <div class="name">{{project.artist_name}}</div>
                    <div class="location">{{project.art_location}}</div>
                    <button type="button" class="btn-audio" *ngIf="project.artist_audio" (click)="click($event, 'audio')">
                        <span class="icon">
                            <svg id="Group_41" data-name="Group 41" xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink" width="48.5" height="36.599" viewBox="0 0 48.5 36.599">
                                <defs>
                                    <clipPath id="clip-path">
                                        <rect id="Rectangle_15" data-name="Rectangle 15" width="48.5" height="36.599"
                                            fill="#83deff" />
                                    </clipPath>
                                </defs>
                                <g id="Group_40" data-name="Group 40" clip-path="url(#clip-path)">
                                    <path id="Path_19" data-name="Path 19"
                                        d="M111.025,70.856,102,75.98c-.376.366-.752,0-.752-.366V65.366c0-.366.376-.732.752-.366l9.023,5.124c.376,0,.376.732,0,.732"
                                        transform="translate(-80.948 -52.19)" fill="#83deff" />
                                    <path id="Path_20" data-name="Path 20"
                                        d="M29.326,36.6H18.8C8.271,36.6,0,28.547,0,18.665A18.922,18.922,0,0,1,18.8,0H29.7A18.679,18.679,0,0,1,48.5,18.665c0,9.882-8.647,17.933-19.174,17.933M18.8,4.026A14.887,14.887,0,0,0,3.76,18.665c0,8.052,6.767,14.274,15.039,14.274H29.7c8.271,0,15.039-6.222,15.039-14.274A14.887,14.887,0,0,0,29.7,4.026Z"
                                        fill="#83deff" />
                                </g>
                            </svg>
                        </span>
                        <span class="label">Artist Audio</span>
                    </button>
                </div>
            </div>
            <div class="buttons">
                <button type="button" class="btn-gradient" *ngIf="project.directions_url" (click)="click($event, 'howto')">How to
                    interact</button>
                <button type="button" class="btn-gradient-icon" *ngIf="project.artist_instagram"
                    (click)="click($event, 'instagram')">
                    <span class="icon">
                        <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="m12 16c2.2091 0 4-1.7909 4-4 0-2.2091-1.7909-4-4-4-2.2091 0-4 1.7909-4 4 0 2.2091 1.7909 4 4 4z"
                                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                            <path
                                d="m3 16v-8c0-2.7614 2.2386-5 5-5h8c2.7614 0 5 2.2386 5 5v8c0 2.7614-2.2386 5-5 5h-8c-2.7614 0-5-2.2386-5-5z"
                                stroke="currentColor" stroke-width="1.5" />
                            <path d="m17.5 6.51 0.01-0.01111" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                stroke-width="1.5" />
                        </svg>
                    </span>
                </button>
            </div>
            
                <div class="dates copy" *ngIf="project.dates_live">
                    <h3><strong>When is this live?</strong></h3>
                    <p [innerHTML]="project.dates_live"></p>
                </div>
                <div class="photo"  [ngClass]="{ nodate: !project.dates_live }" [ngStyle]="{ 'background-image': bgArtist }" *ngIf="project.artist_photo"></div>
                <div class="copy" [innerHTML]="project.project_copy"></div>
            </div>
        </div>
    </div>
</div>